import { register } from "./registry";

register((root) => {
  const page = root.querySelector("[data-page='truck-arrival-entry']");
  if (!page) return;

  const manifestNoInput = page.querySelector<HTMLInputElement>("#manifestNoInput");
  const allOkInput = page.querySelector<HTMLInputElement>("#allOkInput");
  const gridContainer = page.querySelector<HTMLElement>("#arrivalGridContainer");
  const gridBody = page.querySelector<HTMLElement>("#arrivalGridBody");
  const remarksInput = page.querySelector<HTMLElement>("#remarksInput");

  function toggleGrid() {
    if (!allOkInput || !gridContainer) return;
    const val = (allOkInput.value || "").trim().toLowerCase();
    if (val === "n" || val === "no") {
      gridContainer.style.display = "";
    } else {
      gridContainer.style.display = "none";
    }
  }

  if (allOkInput) {
    allOkInput.addEventListener("input", toggleGrid);
    allOkInput.addEventListener("keydown", (e: KeyboardEvent) => {
      if (e.key === "Enter") {
        const val = (allOkInput.value || "").trim().toLowerCase();
        if (val === "y" || val === "yes" || val === "") {
          e.preventDefault();
          if (remarksInput) remarksInput.focus();
        }
      }
    });
  }

  if (manifestNoInput && gridBody) {
    manifestNoInput.addEventListener("keydown", async (e: KeyboardEvent) => {
      if (e.key === "Enter") {
        const seriesEl = page.querySelector<HTMLSelectElement | HTMLInputElement>("[name='ManifestSeriesId']");
        const seriesId = seriesEl ? seriesEl.value : "";
        const no = manifestNoInput.value;
        if (seriesId && no) {
          try {
            const res = await fetch(`/Operations/TruckArrival?handler=Rows&manifestSeriesId=${seriesId}&manifestNo=${no}`);
            if (res.ok) {
              const html = await res.text();
              gridBody.innerHTML = html;
            }
          } catch (err) {
            console.error(err);
          }
        }
      }
    });
  }
});
